var render = function render(){var _vm=this,_c=_vm._self._c;return _c('i',{staticClass:"fal fa-fw",class:_vm.gender_icon(_vm.gender)})
}
var staticRenderFns = []

export { render, staticRenderFns }